import type { Team } from '@uefadigital/panenka';
import { PkBadge, PkIdentifier } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';

import { translateEntity } from 'utils/translateEntity';

import * as style from './style.module.css';

interface ClubFilterData {
  teams: Array<Team>;
  callBack: (el: Team | undefined) => void;
}

export const ClubFilter = ({ teams, callBack }: ClubFilterData) => {
  const { t } = useTranslation();

  if (!teams.length) return <div>{t('no_teams')}...</div>;

  return (
    <div className={style.clubFilter}>
      {teams.map((el, i) => (
        <PkIdentifier onClick={() => callBack(el)} className={style.pointer} key={i} type="vertical">
          <span slot="prefix">
            <PkBadge alt="team" fallbackImage="club-generic-badge" size={64} src={el.logoUrl} />
          </span>
          <span slot="secondary" className="pk-text--text-01 pk-text--wrap pk-font-size--m pk-line-height--sm">
            {translateEntity(el)?.displayName}
          </span>
        </PkIdentifier>
      ))}
    </div>
  );
};
